import { BaseModel } from 'core/base.model';

import { MeasureUnitType, TMeasureUnitType } from '../../../types/measure-unit.type';

export class Product extends BaseModel {
  productCode: string = '0';
  productName: string = '';
  unit: number = 0;
  measureUnit: TMeasureUnitType = MeasureUnitType.mg;
  lastPurchasePrice: number = 0;

  static build(dto: Product) {
    const entity = new Product(dto.id, dto.createdAt, dto.updatedAt);
    entity.productCode = `${dto.productCode}`;
    entity.productName = dto.productName?.toUpperCase();
    entity.unit = dto.unit * 1.0;
    entity.measureUnit = dto.measureUnit;
    entity.lastPurchasePrice = dto.lastPurchasePrice * 1.0;
    if (!entity.productName) throw new Error('Informe o nome do produto.');
    if (entity.unit <= 0) throw new Error('A unidade deve ser maior que zero.');
    return entity;
  }
}
